import { Link } from "react-router-dom";
import type { Work } from "@/mocks/works";

export default function WorkCard({ work }: { work: Work }) {
  return (
    <Link
      to={`/works/${work.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={`${work.title} 封面`}
          title={`${work.title} - 希岛爱理影视作品`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-950/80 text-background-50 text-xs font-medium">
          {work.type}
        </span>
        <span className="absolute top-3 right-3 px-2 py-1 rounded-md bg-accent-500 text-primary-950 text-xs font-semibold">
          {work.year}
        </span>
      </div>
      <div className="p-4">
        <h3 className="font-heading font-semibold text-base text-foreground-950 group-hover:text-primary-700 transition-colors line-clamp-2">
          {work.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1.5">导演 · {work.director}</p>
        <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">{work.synopsis}</p>
      </div>
    </Link>
  );
}